module.exports = __webpack_public_path__ + "static/media/Bnc.0c803d53.jpg";